import { ErrorCode } from './error-code.js';
const ERROR_CODES = new Set(Object.values(ErrorCode));
export default function isErrorCode(value) {
    return ERROR_CODES.has(value);
}
//# sourceMappingURL=is-error-code.js.map